import {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {
  HistoryComponent,
  HistoryComponentProps,
} from 'src/components/elements/account/newHistoryUI/historyComponent';

const SendASnackHistoryList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.sendasnack;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'SendASnackHistoryList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return <HistoryComponent historyfilter={filterTypes.sendasnack} {...props} />;
};

export default SendASnackHistoryList;
